















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TranslationItemModel from "@models/translationItemModel";

@Component
export default class TranslateListComponent extends Vue {
  @Prop() translations: Array<TranslationItemModel>;

  created() {}

  getImage(langCode: string): string {
    return `/assets/img/flags/${langCode.toLocaleLowerCase()}.png`;
  }

  mounted() {}
}
